import {
  SupplierUpdateRequestType,
  SupplierUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSupplierUpdate = (supplierId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: SupplierUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `suppliers/${supplierId}`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as SupplierUpdateResponseType,
      ),
    onSettled: (data) => {
      if (data) {
        queryClient.invalidateQueries({
          queryKey: [business?.id, ServerStateKeys.SuppliersLegacy, data.id],
        });
        queryClient.invalidateQueries({
          queryKey: [
            user?.uid,
            business?.id,
            ServerStateKeys.Suppliers,
            data.id,
          ],
        });
        queryClient.invalidateQueries({
          queryKey: [user?.uid, business?.id, ServerStateKeys.Businesses],
        });
        queryClient.invalidateQueries({
          queryKey: [business?.id, ServerStateKeys.SupplierRecentlyAdded],
        });
      }
    },
  });
};
